<template>
	<div>
		<MainTempComp
			ref="mainTempRef"
			:handleSearch="handleSearch"
			:showPage="false"
		>
			<template #main>
				<tableComp :tableData="data.tableData"></tableComp>
			</template>
		</MainTempComp>
	</div>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./table.vue";
import { apiSysParamList } from "@/api/requestApis.js";
export default {
	name: "systemSettings",
	components: {
		tableComp,
	},
	setup() {
		const mainTempRef = ref(null);

		const data = reactive({
			tableData: [],
		});
		const handleSearch = async () => {
			const res = await apiSysParamList();
			data.tableData = res.records || [];
		};

		const handleUpdateTable = () => {
			handleSearch();
		};
		provide("handleUpdateTable", handleUpdateTable);
		provide("handleSearch", handleSearch);
		onMounted(() => {
			handleSearch();
		});
		return {
			mainTempRef,
			data,
			handleSearch,
		};
	},
};
</script>

<style scoped>
</style>
